import type { CommonColors } from '@mui/material/styles/createPalette'
import type { PaletteColorNoChannels } from './core/palette'
import { DEFAULT_PALETTE } from './theme-palettes'
import type { ThemeDirection, ThemeColorScheme, ThemeCssVariables } from './types'

// --------------------------------------------------------------------------------------------- //

type ThemeConfig = {
  classesPrefix: string
  modeStorageKey: string
  direction: ThemeDirection
  defaultMode: ThemeColorScheme
  cssVariables: ThemeCssVariables
  fontFamily: Record<'primary' | 'secondary', string>
  palette: Record<'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error', PaletteColorNoChannels> & {
    common: Pick<CommonColors, 'black' | 'white'>
    grey: Record<'50' | '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900', string>
  }
}

export const themeConfig: ThemeConfig = {
  // Base
  direction: 'ltr',
  defaultMode: 'dark',
  modeStorageKey: 'theme-mode',
  classesPrefix: 'adex',
  // Typography
  fontFamily: {
    primary: 'Inter Variable',
    secondary: 'Barlow'
  },
  // Palette
  palette: DEFAULT_PALETTE,
  // palette: CUSTOM_PALETTE,
  // Css variables
  cssVariables: {
    cssVarPrefix: '',
    colorSchemeSelector: 'data-color-scheme'
  }
}
